export const pick = <T extends object>(
  object: T,
  keys: (keyof T)[],
): Partial<T> => {
  return keys.reduce((acc, key) => {
    if (key in object) {
      acc[key] = object[key];
    }
    return acc;
  }, {} as Partial<T>);
};

export const removeEmptyProperties = <
  T extends object,
  N = NonEmptyProperties<T>,
>(
  obj: T,
): N => {
  const hasValue = (v: unknown) => v !== null && v !== undefined;
  return Object.fromEntries(
    Object.entries(obj).filter(([_, n]) => hasValue(n)),
  ) as N;
};
type NonEmptyProperties<T> = {
  [K in keyof T as T[K] extends null | undefined ? never : K]: T[K];
};
